<template>
  <div>
    <div class="content-settings">
      <div class="panel panel-primary" :class="{ 'init-panel': initPanel }">
        <div class="panel-heading">{{ $t('manageContentByGrade.manaContentGrade') }}</div>
        <div class="panel-body">
          <div class="row">
            <div class="col-md-12">
              <div v-if="studentIdSelected === ''" class="alert alert-primary" role="alert">
                {{ $t('manageContentByGrade.chooseStudent') }}
              </div>
              <div v-if="studentIdSelected !== ''" class="alert alert-primary" role="alert">
                {{ $t('manageContentByGrade.nowThatYouCorrectly') }}
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-row">
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                  <label class="mb-1" for="name-student">{{ this.$t('manageContentByGrade.chooseAStudent') }}</label>
                  <div class="select-container">
                    <!-- <select
                      id="students"
                      v-model="selectStudent"
                      class="form-control text-capitalize select-style"
                      :disabled="studentIdSelected !== ''"
                      @change="handleChangeStudents"
                    >
                      <option disabled :value="undefined" selected>{{
                        $t('manageContentByGrade.pleaseSelectOne')
                      }}</option>
                      <option
                        v-for="student in students"
                        :key="student.id"
                        class
                        :value="student.id"
                        :data-studentid="student.id"
                        :data-gardeid="student.grade_id"
                        :data-gradeid="student.grade_id"
                        >{{ student.firstname }} {{ student.lastname }}</option
                      >
                    </select>
                    <img src="@/assets/icons/chevronDown.png" alt /> -->
                    <el-select
                      id="students"
                      v-model="selectStudent"
                      class="select-style select-student"
                      :disabled="studentIdSelected !== ''"
                      :loading="loading"
                      :remote-method="getAllStudents"
                      @change="handleChangeStudents"
                    >
                      <!-- <el-option v-if="loading === true" disabled :value="undefined" selected>loading</el-option> -->
                      <el-option disabled :value="undefined" selected>{{
                        $t('manageContentByGrade.pleaseSelectOne')
                      }}</el-option>
                      <el-option
                        v-for="student in students"
                        :key="student.id"
                        :value="student.id"
                        :label="student.firstname + ' ' + student.lastname"
                        >{{ student.firstname }} {{ student.lastname }}</el-option
                      >
                    </el-select>
                  </div>
                </div>
                <div v-if="showInputSelectGrade" class="col-12 col-sm-6 col-md-3 mb-3">
                  <label class="mb-1" for="grade">{{ $t('manageContentByGrade.grade') }}</label>
                  <div class="select-container">
                    <select
                      id="grades"
                      v-model="gradeIdSelected"
                      class="form-control text-capitalize select-style"
                      @change="handleChangeGrades"
                    >
                      <option v-for="grade in grades" :key="grade.id" :value="grade.id" :data-gradeid="grade.id">{{
                        grade.name
                      }}</option>
                    </select>
                    <img src="@/assets/icons/chevronDown.png" alt />
                    <!-- <el-select id="grades" v-model="gradeIdSelected" class="select-style" @change="handleChangeGrades">
                      <el-option
                        v-for="grade in grades"
                        :key="grade.id"
                        :value="grade.id"
                        :data-gradeid="grade.id"
                        :label="grade.name"
                      ></el-option>
                    </el-select> -->
                  </div>
                </div>
                <div v-if="showBtnSave" class="divButton col-12 col-md-5">
                  <button type="button" class="btn btn-primary btn-save" @click="forceUpdate">
                    {{ $t('manageContentByGrade.chooseAnotherStudent') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-12" :class="{ 'content-panel': initPanel }">
              <div v-if="initPanel" class="alert alert-primary init-alert" role="alert">
                {{ $t('manageContentByGrade.studentHasNotBeen') }}
              </div>
              <div
                v-for="(subject, subjectIndex) in gradeSelected.subjects"
                :key="subjectIndex"
                class="row subject-block"
              >
                <div class="col-md-3">
                  <div class="subject-name">
                    <img :src="subject.icon" class="rounded-circle subject-name-item" alt height="50" width="50" />
                    <label class="subject-name-item">{{ subject.name | deleteNumbers }}</label>
                  </div>
                  <div v-if="gradeSelected.id != 2 && gradeSelected.id != 5" class="settings-test">
                    <ul class="actions">
                      <li class="mb-3 actions-item">
                        <span class="mr-2">{{ $t('manageContentByGrade.pretest') }}:</span>
                        <el-switch
                          v-model="subject.can_make_quiz"
                          :active-text="$t('manageContentByGrade.enable')"
                          :inactive-text="$t('manageContentByGrade.disable')"
                        >
                        </el-switch>
                      </li>
                      <li class="mb-3 actions-item">
                        <span class="mr-2">{{ $t('manageContentByGrade.test') }}:</span>
                        <el-switch
                          v-model="subject.can_make_test"
                          :active-text="$t('manageContentByGrade.enable')"
                          :inactive-text="$t('manageContentByGrade.disable')"
                        >
                        </el-switch>
                      </li>
                      <li class="mb-3 actions-item">
                        <span class="mr-2">{{ $t('manageContentByGrade.setTime') }}:</span>
                        <el-select v-model="subject.seconds_per_question" placeholder="Select" size="mini">
                          <el-option :label="$t('manageContentByGrade.notTime')" :value="0"> </el-option>
                          <el-option :label="$t('manageContentByGrade.seconds15')" :value="15"> </el-option>
                          <el-option :label="$t('manageContentByGrade.seconds30')" :value="30"> </el-option>
                          <el-option :label="$t('manageContentByGrade.seconds45')" :value="45"> </el-option>
                          <el-option :label="$t('manageContentByGrade.minute1')" :value="60"> </el-option>
                          <el-option :label="$t('manageContentByGrade.minute130')" :value="90"> </el-option>
                          <el-option :label="$t('manageContentByGrade.minute2')" :value="120"> </el-option>
                          <el-option :label="$t('manageContentByGrade.minute230')" :value="150"> </el-option>
                          <el-option :label="$t('manageContentByGrade.minute3')" :value="180"> </el-option>
                        </el-select>
                      </li>
                      <li class="d-flex justify-content-end">
                        <el-button type="primary" @click="saveSubjectExamSettings(subject)">{{
                          $t('singup.submit')
                        }}</el-button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-9 cluster-block">
                  <div class="cluster-select-all" @click="lockSubjectToggle(subjectIndex)">
                    <img v-if="subject.is_locked" src="@/assets/tutor/checkAllGreen.png" class alt="Uncheck All" />
                    <img v-if="!subject.is_locked" src="@/assets/tutor/checkAllGrey.png" class alt="Check All" />
                    <label>{{ $t('manageContentByGrade.selectAll') }}</label>
                  </div>
                  <div
                    v-for="(cluster, clusterIndex) in gradeSelected.subjects[subjectIndex].clusters"
                    :key="cluster.id"
                    class
                  >
                    <div class="cluster-name">
                      <i
                        v-if="cluster.is_locked"
                        class="fa fa-lock cluster-name-item lock-color"
                        @click="lockClusterToggle(subjectIndex, clusterIndex, cluster.id)"
                      ></i>
                      <i
                        v-else
                        class="fa fa-unlock cluster-name-item unlock-color"
                        @click="lockClusterToggle(subjectIndex, clusterIndex, cluster.id)"
                      ></i>
                      <label
                        class="cluster-name-item text-capitalize"
                        @click="lockClusterToggle(subjectIndex, clusterIndex, cluster.id)"
                        >{{ cluster.nombre }}</label
                      >
                    </div>
                  </div>
                </div>
                <hr />
              </div>
              <!-- #Lista de materias end -->
            </div>
          </div>
        </div>
      </div>
      <!-- #panel body end -->
    </div>
    <!-- #panel end -->
  </div>
</template>

<script>
// import Toasted from 'vue-toasted'
import { mapGetters } from 'vuex';
import _ from 'lodash';
// import swal from 'sweetalert'
export default {
  name: 'ManageContentByGrade',
  data() {
    return {
      // Muestra u oculta el modal 'settings of the test'
      showSettingsOfTheTest: false,
      // Muestra el mensage 'Student has not been selected yet.' cuando se inicia el componente y aun no se ha realizado ninguna consulta de algún estudiante.
      initPanel: true,
      // Muestra o oculta el select que muestra todos los grados.
      showInputSelectGrade: false,
      // Muestra el boton de guardar
      showBtnSave: false,
      // Almacena todos los estudiantes obtenidos de la base de datos
      students: [],
      // Alamcena el id, name y path de los grados obtenido de la base de datos
      grades: [],
      // Almacena la configuraciones de un test o pretest obtenida de la base de datos
      settingOfTestFromDB: {},
      settingOfPretestFromDB: {},
      // Crea la nueva configuración y lo almacena en setting
      setting: {},
      settingPretest: {},
      // Pertenecen al modelo setting
      statusTest: true,
      timeOfTest: 0,
      statusPreTest: true,
      timeOfPretest: 0,
      subjectPathSelected: '',
      // Alamcena el grado seccionado
      gradeSelected: [],
      // Objecto con información que utiliza para enviar al servidor con los datos de la petición (data, token).
      payload: {
        token: this.$store.state.cookie,
      },
      // v-models
      gradeIdSelected: '',
      studentIdSelected: '',
      // Facilita resetear el valor del select de estudiantes
      selectStudent: undefined,
      // Indica el tutor "Choose a student" o "Name of student"
      lblInputStudent: this.$t('manageContentByGrade.chooseAStudent'),
      // Alamacena el path del grado seleccionado
      itemsPerRow: 5,
      // Dependiendo de su valor se añade la clase active en los input type radio
      isTrueTest: true,
      isFalseTest: false,
      isTruePretest: true,
      isFalsePretest: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/authenticatedUser',
    }),
  },
  created() {
    this.getAllStudents();
    this.fetchGrades();
  },
  methods: {
    saveSubjectExamSettings(subject) {
      this.$httpMain
        .post('subject-exam-settings', {
          subject_id: Number.parseInt(subject.id),
          can_make_quiz: subject.can_make_quiz,
          can_make_test: subject.can_make_test,
          user_id: Number.parseInt(this.studentIdSelected),
          seconds_per_question: subject.seconds_per_question,
        })
        .then(res => {
          console.log(res);
          this.$notify({
            title: 'Success',
            message: 'Everything went well successful',
            type: 'success',
          });
        })
        .catch(err => {
          this.$notify.error({
            title: 'Error',
            message: err.message,
          });
        });
    },
    handleChangeStudents(id) {
      const student = _.find(this.students, ['id', id]);

      if (student) {
        console.log('student', student);
        this.gradeIdSelected = student.garde_id;
        this.gradeIdSelected = student.grade_id;
        this.studentIdSelected = id;
        this.showInputSelectGrade = true;
        this.lblInputStudent = this.$t('evaluation.studentName');
        this.showBtnSave = true;
        this.initPanel = false;
      }
      this.getContentOfGradeSelected();
    },
    handleChangeGrades(e) {
      if (e.target.options.selectedIndex > -1) {
        this.gradeIdSelected = e.target.options[e.target.options.selectedIndex].dataset.gradeid;
      }
      this.getContentOfGradeSelected();
    },
    /** Obtiene le contenido de la base de datos del grado seleccionado */
    getContentOfGradeSelected() {
      this.$httpMain
        .post(`get_content_of_grade_selected`, {
          student_id: Number.parseInt(this.studentIdSelected),
          grade_id: Number.parseInt(this.gradeIdSelected),
        })
        .then(e => {
          this.gradeSelected = e.data;
        });
    },
    /** Notifica al servidor para recibir como respuesta todos los usuarios del tipo student de la base de datos. */
    getAllStudents() {
      this.loading = true;
      setTimeout(() => {
        this.$httpMain
          .post(`get-all-user-by-rol`, {
            type_user: '1',
            tutor_id: this.user.id,
          })
          .then(res => {
            console.log(res);
            this.students = res.data;
            //this.$store.commit('STOP_PROCESSING');
          })
          .catch(err => {
            console.log(err);
            //this.$store.commit('STOP_PROCESSING');
          })
          .finally(() => {
            this.loading = false;
          });
      }, 200);
    },
    /** Notifica al servidor para recibir como respuesta todos los grados de la base de datos (id, name, path) */
    fetchGrades() {
      this.$httpMain
        .get('grades')
        .then(res => {
          this.grades = res.data;
        })
        .catch(() => {
          this.grades = [];
        });
      // .finally(() => {
      //   this.loading = false;
      // });
    },
    lockSubjectToggle(subjectIndex) {
      let subjectId = this.gradeSelected.subjects[subjectIndex].id;
      this.$httpMain
        .post('lock-all-subject-clusters', {
          subject_id: Number.parseInt(subjectId),
          lock: !this.gradeSelected.subjects[subjectIndex].is_locked,
          user_id: Number.parseInt(this.studentIdSelected),
        })
        .then(() => {
          let self = this;
          this.gradeSelected.subjects[subjectIndex].is_locked = !this.gradeSelected.subjects[subjectIndex].is_locked;
          this.gradeSelected.subjects[subjectIndex].clusters.forEach(function (cluster, index) {
            self.gradeSelected.subjects[subjectIndex].clusters[index].is_locked = !self.gradeSelected.subjects[
              subjectIndex
            ].is_locked;
          });
          this.$notify({
            title: 'Success',
            message: 'Everything went well successful',
            type: 'success',
          });
        })
        .catch(err => {
          this.$notify.error({
            title: 'Error',
            message: err.message,
          });
        })
        .finally(() => {});
    },
    /** Habilita o deshabilita el cluster seleccionado por el lado del front end */
    lockClusterToggle(subjectIndex, clusterIndex, clusterId) {
      this.$httpMain
        .post('lock-cluster', {
          cluster_id: Number.parseInt(clusterId),
          lock: !this.gradeSelected.subjects[subjectIndex].clusters[clusterIndex].is_locked,
          user_id: Number.parseInt(this.studentIdSelected),
        })
        .then(() => {
          this.gradeSelected.subjects[subjectIndex].clusters[clusterIndex].is_locked = !this.gradeSelected.subjects[
            subjectIndex
          ].clusters[clusterIndex].is_locked;
          this.$notify({
            title: 'Success',
            message: 'Everything went well successful',
            type: 'success',
          });
        })
        .catch(err => {
          this.$notify.error({
            title: 'Error',
            message: err.message,
          });
        })
        .finally(() => {});
    },
    /** Update component */
    forceUpdate() {
      // Object.assign(this.$data, this.initialData())
      this.studentIdSelected = '';
      this.initPanel = true;
      this.lblInputStudent = 'Choose a student';
      this.showInputSelectGrade = false;
      this.gradeSelected = [];
      this.showBtnSave = false;
      this.selectStudent = undefined;
    },
  },
};
</script>
<style lang="scss" scoped>
.actions {
  padding: 0.5em;
  border-radius: 5px;
  border: 1px solid #ff8829;
}
.actions-item {
  display: flex;
  justify-content: space-between;
}
/*
   TOC:
  =======

  1. Primary Styles

  2. Custom Utility Classes

  3. Custom Styles

===================================================== */

/* --------------------------------- */
/* 1. Primary Styles
 ----------------------------------- */
a:link {
  text-decoration: none;
  display: block;
}
i {
  margin-right: 0.3rem;
}
/* --------------------------------- */
/* 2. Custom Utility Classes
 ----------------------------------- */
.lock-color {
  color: #b2b5b7;
}
.unlock-color {
  color: #ffc107;
}
.content-settings {
  // height: calc(100vh - 30px);
  font-family: 'comfortaabold';
  padding-left: 10px;
  padding-right: 10px;
  max-width: 1600px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: min-content;
  margin: 0 auto;
}
.init-panel {
  height: 80vh;
}
.content-panel {
  height: 50vh;
  display: flex;
  align-items: center;
}
.content-panel .init-alert {
  margin: 0 auto;
  max-width: 325px;
  text-align: center;
}
.panel {
  background-color: #fff;
  border: 0;
  border-radius: 10px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  max-width: 1400px;
  margin: 35px 0;
}
.panel-primary > .panel-heading {
  color: #fff;
  background-color: #55c5cc;
  border-color: #fff;
  font-size: 1.5rem;
}
.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.panel-body {
  padding: 15px;
}
.subject-name {
  display: flex;
}
.subject-name-item {
  align-self: center;
  // margin-left: 1rem;
}
label.subject-name-item {
  margin: 0 1rem;
  // font-weight: bold;
  font-family: 'comfortaabold';
  font-size: 1.2rem;
}
.cluster-name {
  display: flex;
  margin-bottom: 0.8rem;
}
.cluster-name-item {
  align-self: center;
  cursor: pointer;
}
.cluster-name-item:hover {
  font-weight: 600;
}
label.cluster-name-item {
  line-height: 1.5;
  margin: 0 0.3rem;
}
.subject-block {
  margin-left: 0px;
  margin-right: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  padding: 1.5rem 0;
}
.subject-block:nth-child(1) {
  margin-top: 1.5rem;
}
.cluster-block {
  display: flex;
  flex-wrap: wrap;
}
.cluster-select-all {
  display: flex;
  align-items: center;
  padding: 0rem 0.2rem 0.5rem;
  width: 45%;
  margin: 0.8rem 55% 0.5rem 0;
  border-bottom: 1px solid #b0b0b0;
}
.cluster-select-all img {
  width: 20px;
  cursor: pointer;
}
.cluster-select-all label {
  // height: 10px;
  color: #ff7021;
  margin: 0;
  margin-left: 5px;
  cursor: pointer;
}
.cluster-select-all ~ div {
  padding: 0rem 0.5rem;
  min-width: 50%;
  max-width: 50%;
}
.settings-test {
  margin-top: 10%;
  // margin-left: 1rem;
}
.settings-test button {
  background-color: #1169a4;
  padding: 0.5rem 0.5rem 0.3rem;
}
.test-sub-title {
  display: inline-block;
  margin-right: 2rem;
  // min-width: 4rem;
  margin: 1.2rem 0 0 0;
}
.enable-disable-test {
  display: flex;
  justify-content: space-between;
}
.btn-save {
  position: absolute;
  top: 1.5rem;
  right: 0.5rem;
}
.active {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
  color: white !important;
}
.disable {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
  color: white !important;
}
.btn.btn-primary.lbl-custom {
  color: black;
  background-color: #ffffff;
  // border-color: #007bff;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.close {
  cursor: pointer;
}
.options {
  display: flex;
  justify-content: flex-end;
}
.options button {
  margin-left: 0.5rem;
}
/* --------------------------------- */
/* 3. Custom Styles
 ----------------------------------- */
/*customizing boostrap*/
.select-style {
  box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.5);
}
.select-student {
  font-size: 17pt;
  color: red;
}
.btn-tests {
  cursor: pointer;
  background-color: #78c25f !important;
  border-color: #78c25f;
}
.btn-tests:hover {
  background-color: rgb(33, 110, 8) !important;
  border-color: #78c25f;
}
.btn-tests:active {
  border-color: #78c25f !important;
}
.btn-tests:focus {
  border-color: #78c25f !important;
}
.btn-save {
  cursor: pointer;
  // max-width: 210px;
  background-color: #ff6d00 !important;
  border-color: #ff6d00 !important;
}
.btn-save:hover {
  background-color: rgba($color: rgb(255, 123, 0), $alpha: 0.9) !important;
  border-color: #ff6d00 !important;
}
.modal-content {
  border-radius: 10px !important;
}
.modal-header {
  background-color: #55c5cc;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px 15px !important;
}
.modal-body-custom {
  padding: 1.5rem 3rem;
}
.btn.btn-primary.lbl-custom {
  height: 1.5rem;
  line-height: 0.4rem;
}
.btn-group {
  margin: 1.2rem 0 0 0;
}
/*Vue transition*/
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.alert {
  border-radius: 3px;
  padding: 5px 10px;
}
.alert-primary {
  // background-color: rgba($color: #55C5CC, $alpha: 0.6);
  background-color: transparent;
  border: 0;
  border-bottom: 5px solid #ff6d00;
  color: #265e9b;
}
.text-capitalize {
  text-transform: capitalize;
}
.select-container {
  position: relative;
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
  }
  img {
    position: absolute;
    margin: auto;
    right: 10px;
    width: 10px;
    top: 0;
    bottom: 0;
    pointer-events: none;
  }
}
@media (max-width: 576px) {
  .divButton {
    height: 60px;
  }
  .select-style {
    width: 90%;
  }
  .select-container img {
    right: 15%;
  }
  .cluster-block {
    display: block;
  }
  .cluster-select-all ~ div {
    min-width: 50%;
    max-width: 100%;
  }
}
@include forTablet() {
  .divButton {
    height: 60px;
  }
}
@include forTabletLandscape() {
  label.subject-name-item {
    margin: 0px 5px;
  }
}
@media (max-width: 1026px) {
  .panel {
    height: inherit;
  }
}
</style>
